import {filter, map, shareReplay, startWith} from 'rxjs/operators';
import {wwData$} from './worker-data';
import {genShareReplyWithSubscribeHook} from '@px/helper/stream';
import {loadAssetsOverviewData$} from './data/assets';
import Msg = ww.Msg;
import AssetsData = ww.AssetsData;

export const assets$ = genShareReplyWithSubscribeHook(
  wwData$.pipe(
    filter((o: Msg<AssetsData>) => o.type === 'assets'),
    map((o: Msg<AssetsData>) => o.data.assets),
    startWith(initAssets()),
    shareReplay(1)
  ),
  () => {
    loadAssetsOverviewData$.next();
  }
);

function initAssets() {
  const asset = {
    btcEv: 0,
    btc: '--',
    usdEv: 0,
    usd: '--',
    money: '--',
    usdtEv: 0,
    usdt: '--',
  };
  return {
    isInit: true,
    ...asset,
    localCurrency: '',
    details: {
      spot: asset,
      spotMargin: asset,
      spotStrategy: asset,
      contract: asset,
      contractStrategy: asset,
      copyTrade: asset,
      investment: asset,
      fiat: asset,
      lending: asset,
      trading: asset,
      funding: asset,
      spotAll: asset,
      contractAll: asset,
      tradingAll: asset,
      tradingBot: asset,
    },
  };
}
